import { createSlice } from '@reduxjs/toolkit'

const slice = createSlice({
  name: 'rtmEventGpsValues',
  initialState: {},
  reducers: {
    setGpsValues: (state, { payload }) => {
      state[payload.eventId] = payload.data
    },
  },
})

export const { setGpsValues } = slice.actions

export default slice.reducer

export const selectGpsValues = (eventId) => (state) =>
  state.rtmEventGpsValues[eventId]
